import type { SxProps, Theme } from '@mui/material'
import { FIXED_EVENT_LABEL_SIZE, FIXED_TIMESTAMP_SIZE } from '../shared'

export const bubbleContainerSx: SxProps<Theme> = {
  width: '100%',
  mb: 2,
}

export const eventLabelSx = (color: string): SxProps<Theme> => ({
  fontWeight: 600,
  color,
  fontSize: FIXED_EVENT_LABEL_SIZE,
})

export const clickableEventLabelSx = (color: string): SxProps<Theme> => ({
  fontWeight: 600,
  color,
  cursor: 'pointer',
  transition: 'color 0.2s',
  '&:hover': {
    color: 'primary.main',
  },
  fontSize: FIXED_EVENT_LABEL_SIZE,
})

export const timestampSx: SxProps<Theme> = {
  display: 'block',
  mt: 0.5,
  textAlign: 'left',
  fontSize: FIXED_TIMESTAMP_SIZE,
}
